export function parseUrlArgsGS(
    urlString: string,
    baseUrl?: string
): Record<string, string> {
    const url = baseUrl === undefined
        ? new URL(urlString)
        : new URL(urlString, baseUrl);
    const args: Record<string, string> = {};

    url.pathname.split('/').filter(Boolean).forEach((component, index) => {
        args[`path${index}`] = decodeURIComponent(component);
    });
    url.searchParams.forEach((value, key) => { args[key] = value; });
    return args;
}
